module.exports = __webpack_public_path__ + "static/media/Otros Sistemas.f47d2199.svg";